module.exports = __webpack_public_path__ + "img/TimeElapsed.7e6d2b54.png";